import { string } from "prop-types";
import { useCallback } from "react";

import styled from "styled-components";

import { useIsRegularUser } from "Flocknote/stateHooks";

import FnrContainedIcon from "UI/FnrContainedIcon";

import externalNavigate from "Utilities/externalNavigate";

import { ButtonWrapper } from "../shared";

const DisplayComponent = ({ color }) => (
  <FnrContainedIcon color={color} size="lg" icon="fa-home fas" />
);

DisplayComponent.propTypes = { color: string };

const ButtonDisplay = () => {
  const isRegularUser = useIsRegularUser();

  const handleClick = useCallback(() => {
    if (isRegularUser) {
      externalNavigate("/home", "_self");
    } else {
      externalNavigate("/dashboard", "_self");
    }
  }, [isRegularUser]);

  return (
    <SButtonWrapper
      onClick={handleClick}
      data-cy="MemberToolbar_HomeButton"
      DisplayComponent={DisplayComponent}
    />
  );
};

const SButtonWrapper = styled(ButtonWrapper)`
  display: flex;
  width: 40px;
  justify-content: center;
  align-items: center;
`;

export default ButtonDisplay;
